var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var TagIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 56,
    glyphHeight: 57
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4075 0.324865C26.177 0.170967 26.9726 0.209427 27.7237 0.436832C28.4747 0.664237 29.158 1.07355 29.7129 1.62844L54.6078 26.5233C55.0504 26.9659 55.4015 27.4914 55.6411 28.0697C55.8806 28.6481 56.0039 29.2679 56.0039 29.8939C56.0039 30.5198 55.8806 31.1397 55.6411 31.718C55.4015 32.2963 55.0504 32.8218 54.6078 33.2645L33.0361 54.8362C32.5934 55.2788 32.0679 55.6299 31.4896 55.8695C30.9113 56.109 30.2914 56.2323 29.6655 56.2323C29.0395 56.2323 28.4197 56.109 27.8413 55.8695C27.263 55.6299 26.7375 55.2788 26.2949 54.8362L1.40005 29.9413C0.845158 29.3864 0.435843 28.7031 0.208438 27.9521C-0.0189663 27.201 -0.0574264 26.4054 0.0964718 25.6359L2.90096 26.1968L0.0964725 25.6359L3.94105 6.41303C4.16748 5.28086 5.05246 4.39587 6.18464 4.16944L25.4075 0.324866L25.9684 3.12936L25.4075 0.324865ZM26.029 6.03391L9.1761 9.40449L5.80552 26.2574L29.6655 50.1173L49.889 29.8939L26.029 6.03391Z"
  }), React.createElement("path", {
    d: "M17.9232 21.4421C20.0293 21.4421 21.7366 19.7348 21.7366 17.6287C21.7366 15.5226 20.0293 13.8153 17.9232 13.8153C15.8172 13.8153 14.1099 15.5226 14.1099 17.6287C14.1099 19.7348 15.8172 21.4421 17.9232 21.4421Z"
  }));
};
export var TagIconGlyph = function (props) {
  return React.createElement(TagIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};